// src/components/ModalAgregarUsuario.jsx
import React, { useState } from "react";
import clienteAxios from "../../axios";

const ModalAgregarUsuario = ({ show, onClose, onUsuarioAgregado }) => {
    const [nuevoUsuario, setNuevoUsuario] = useState({
        celular: "",
        nombre: "",
        correo: "",
        clave: "",
        activo: 1,
        idperfil: ""
    });

    const handleAgregarUsuario = async (e) => {
        e.preventDefault();
        if (!nuevoUsuario.celular || !nuevoUsuario.nombre || !nuevoUsuario.correo || !nuevoUsuario.clave || !nuevoUsuario.idperfil) {
            alert("Todos los campos son requeridos.");
            return;
        }

        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Agregar",
                modulo: "usuarios",
                celular: nuevoUsuario.celular,
                nombre: nuevoUsuario.nombre,
                correo: nuevoUsuario.correo,
                clave: nuevoUsuario.clave,
                activo: nuevoUsuario.activo,
                idperfil: nuevoUsuario.idperfil
            });

            onUsuarioAgregado(); // Actualizar lista de usuarios
            onClose(); // Cerrar modal
            setNuevoUsuario({ celular: "", nombre: "", correo: "", clave: "", activo: 1, idperfil: "" }); // Limpiar formulario
        } catch (error) {
            console.log(error);
        }
    };

    if (!show) return null;

    return (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-75 flex justify-center items-center">
            <div className="bg-white p-6 rounded-lg shadow-lg w-96">
                <h2 className="text-xl font-bold mb-4">Agregar Nuevo Usuario</h2>
                <form onSubmit={handleAgregarUsuario}>
                <input
                        type="text"
                        value={nuevoUsuario.celular}
                        onChange={(e) => {
                            const input = e.target.value;
                           
                            if (/^\d*$/.test(input) && input.length <= 10) {
                                setNuevoUsuario({ ...nuevoUsuario, celular: input });
                            }
                        }}
                        placeholder="Teléfono"
                        maxLength="10" 
                        inputMode="numeric"
                        className="border rounded-lg p-2 mb-2 w-full"
                    />
                    <input
                        type="text"
                        value={nuevoUsuario.nombre}
                        onChange={(e) => setNuevoUsuario({ ...nuevoUsuario, nombre: e.target.value })}
                        placeholder="Nombre"
                        className="border rounded-lg p-2 mb-2 w-full"
                        maxLength={50}
                    />
                    <input
                        type="email"
                        value={nuevoUsuario.correo}
                        onChange={(e) => setNuevoUsuario({ ...nuevoUsuario, correo: e.target.value })}
                        placeholder="Correo Electrónico"
                        className="border rounded-lg p-2 mb-2 w-full"
                        maxLength={30}
                    />
                    <input
                        type="password"
                        value={nuevoUsuario.clave}
                        onChange={(e) => setNuevoUsuario({ ...nuevoUsuario, clave: e.target.value })}
                        placeholder="Contraseña"
                        className="border rounded-lg p-2 mb-2 w-full"
                        maxLength={50}
                    />
                    <input
                        type="number"
                        value={nuevoUsuario.idperfil}
                        onChange={(e) => setNuevoUsuario({ ...nuevoUsuario, idperfil: e.target.value })}
                        placeholder="ID de Perfil"
                        className="border rounded-lg p-2 mb-2 w-full"
                        maxLength={10}
                    />
                    <div className="flex justify-end">
                        <button type="submit" className="bg-green-500 rounded text-white px-4 py-2 mr-2">
                            Agregar
                        </button>
                        <button type="button" onClick={onClose} className="bg-gray-500 rounded text-white px-4 py-2">
                            Cancelar
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ModalAgregarUsuario;
